import { Box, Flex, HStack, Spacer, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { AiOutlinePlus } from 'react-icons/ai'
import { BsChevronDoubleDown } from 'react-icons/bs'
import CreateStoreModal from '../Components/CreateStoreModal'
import Pagination from '../Components/Pagination'
import Preloader from '../Components/Preloader'
import TableRow from '../Components/TableRow'
import MainLayout from '../Layouts/Index'
import { GetAllCategories, GetAllStores } from '../Utils/ApiCalls'
import Seo from '../Utils/Seo'
import { configuration } from '../Utils/config'

export default function ManageStore() {

    const { isOpen, onOpen, onClose } = useDisclosure();


    const [ModalState, setModalState] = useState("");
    const [Data, setData] = useState([]);
    const [CategoryData, setCategoryData] = useState([]);

    const [CurrentPage, setCurrentPage] = useState(1);
    const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);
  
    //get current post
  
    const indexOfLastSra = CurrentPage * PostperPage;
    const indexOfFirstSra = indexOfLastSra - PostperPage;
    const currentStore = Data.slice(indexOfFirstSra, indexOfLastSra);
    const currentCategory = CategoryData.slice(indexOfFirstSra, indexOfLastSra);
    //change page 
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }
    const [TotalData, setTotalData] = useState("");
    const [CategoryTotalData, setCategoryTotalData] = useState("");


    const [UpdateStorePayload, setUpdateStorePayload] = useState({
        id: "",
        name: ""
    });
    const [UpdateCategoryPayload, setUpdateCategoryPayload] = useState({
        id: "",
        name: ""
    });

    const [PreLoader, setPreLoader] = useState(true);


    const handleStore = () => {
        setModalState("store")
        onOpen()
    }
    const handleCategory = () => {
        setModalState("category")
        onOpen()
    }

    const handleStoreUpdate = (id, name) => {
        setUpdateStorePayload({
            id,
            name
        })
        setModalState("update Store")
        onOpen()
    }
    const handleCategoryUpdate = (id, name) => {
        setUpdateCategoryPayload({
            id,
            name
        })
        setModalState("update Category")
        onOpen()
    }


    const AllStores = async () => {
        let result = await GetAllStores()

        console.log("allstores", result)

        if (result.status == true) {
            setData(result.queryresult)
            setTotalData(result.queryresult.length)
            setPreLoader(false)
        }
    }
    const AllCategories = async () => {
        let result = await GetAllCategories()
        // console.log();

        if (result.status == true) {
            setCategoryData(result.queryresult.categorydetails)
            setCategoryTotalData(result.queryresult.totalcategorydetails)
            setPreLoader(false)
        }
    }


    useEffect(() => {
        AllStores()
        AllCategories()
    }, [isOpen]);
    return (
        <MainLayout>
        {
            PreLoader && (

                <Preloader/>
            )
        }
        <Seo title="Manage Store" description='EKO IMS - Manage Store' />


            <Flex justifyContent={"space-between"} flexWrap="wrap" fontWeight={"500"} >
            <Seo title='Store Received Advice' description='EKO IMS - Store Received Advice'/>


              
                <HStack onClick={handleCategory} cursor={"pointer"} _hover={{ color: "blue.blue600" }}>
                    <Box>
                        <AiOutlinePlus />
                    </Box>
                    <Text>Create Category </Text>

                </HStack>

            </Flex>


            <Flex justifyContent={"space-between"}>



            </Flex>

            <Flex justifyContent="space-between" mt="32px" flexDir={["column", "column", "column", "row", "row"]} color="#fff">
                <Box pos="relative" p="15px" w={["100%", "100%", "100%", "49%", "49%"]} bg="blue.blue200" h="70vh" minH="70vh" overflowY="hidden" _hover={{ overflowY: "auto" }} rounded="8px">
                    <HStack>
                        <Text textTransform="uppercase" fontSize="20px">Stores</Text>
                        <Spacer />
                        <Text textTransform="uppercase" fontSize="20px">Total Stores - {TotalData}</Text>
                    </HStack>

                    <TableContainer mt="32px" width={"100%"}

                    >
                        <Table variant='simple' size='sm'>
                            <Thead>
                                <Tr>
                                    <Th color={"#fff"}>S/N</Th>
                                    <Th color={"#fff"}>Store Name</Th>

                                </Tr>
                            </Thead>
                            <Tbody>
                            {
                                currentStore.map((item, i)=>(

                                    // console.log("item", item.name)

                                    <TableRow sn={i+1}
                                    
                                    storeName={item.name} key={i}
                                    type={"store"}
                                    />
                                ))
                            }


                            </Tbody>

                        </Table>
                    </TableContainer>

                    <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data.length} paginate={paginate} />


                </Box>
                <Box p="15px" mt={["10px", "10px", "10px", "0px", "0px"]} w={["100%", "100%", "100%", "49%", "49%"]} bg="blue.blue300" h="70vh" minH="70vh" overflowY="hidden" _hover={{ overflowY: "auto" }} rounded="8px">
                    <HStack>
                        <Text textAlign="center" textTransform="uppercase" fontSize="18px"> Categories</Text>
                        <Spacer />
                        <Text textTransform="uppercase" fontSize="18px">Total Categories - {CategoryTotalData}</Text>
                    </HStack>
                    <TableContainer mt="32px" width={"100%"}

                    >
                        <Table variant='simple' size='sm'>
                            <Thead>
                                <Tr>
                                    <Th color={"#fff"}>S/N</Th>
                                    <Th color={"#fff"}>Category Name</Th>
                                    <Th color={"#fff"}>Update</Th>

                                </Tr>
                            </Thead>
                            <Tbody>

                                {
                                    currentCategory.map((item, i) => {

                                        return <TableRow
                                            key={i}
                                            sn={i + 1}
                                            CategoryName={item.name}
                                            type={"category"}
                                            onClick={()=>handleCategoryUpdate(item._id, item.name)}
                                        />
                                    })
                                }



                            </Tbody>

                        </Table>
                    </TableContainer>

                    <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={CategoryData.length} paginate={paginate} />


                </Box>
            </Flex>

            <CreateStoreModal onClose={onClose} onOpen={onOpen} isOpen={isOpen} state={ModalState} storePayload={UpdateStorePayload} categoryPayload={UpdateCategoryPayload} />
        </MainLayout>
    )
}
